module.exports = __webpack_public_path__ + "static/media/(V)_MG_4835_-_bijuterias.bcd7ab7e.jpg";